import React from "react";

export default function AudioStatusPill({
  mode,
  hasServerKey,
  hasPersonalKey,
  onOpenSettings
}) {
  let label = "Audio settings";
  let tone = "limited";
  let note = "Browser speech";

  if (mode === "server-ai-audio") {
    tone = "good";
    note = "AI audio";
  } else if (mode === "personal-key-ai-audio") {
    tone = "good";
    note = "AI audio";
  } else if (mode === "personal-key-browser-fallback") {
    tone = "limited";
    note = "Browser speech";
  } else if (mode === "browser-speech-fallback") {
    tone = "limited";
    note = "Browser speech";
  }

  const titleLines = [`Mode: ${mode || "unknown"}`];

  if (mode !== "browser-speech-fallback") {
    titleLines.push(`Server key: ${hasServerKey ? "yes" : "no"}`);
    titleLines.push(`Personal key: ${hasPersonalKey ? "yes" : "no"}`);
  }

  return (
    <button
      className={`audio-status-pill audio-status-pill--${tone}`}
      type="button"
      onClick={onOpenSettings}
      aria-label="Open audio settings"
      title={titleLines.join(" | ")}
    >
      <span className="audio-status-pill__label">{label}</span>
      <span className="audio-status-pill__dot" />
      <span className="audio-status-pill__note">{note}</span>
    </button>
  );
}
